<template>
    <div class="aside-l" v-if="isLogin">
        <el-button class="btn btn-new" icon="el-icon-plus" @click="addChatGroup">创建新对话</el-button>
        <div class="chat-list" v-if="chatList.length>0">
            <div
                    :class="['item z-flex z-flex-between',activeChat === index ? 'active' : '']"
                    v-for="(item, index) in chatList"
                    :key="index"
                    @click="changeChatReco(index)"
            >
                <div class="item-l z-flex">
                    <i class="icon el-icon-chat-line-square"></i>
                    <div>
                        <div class="msg" v-html="item.title"></div>
                        <el-button
                                class="btn-export"
                                type="text"
                                icon="el-icon-printer"
                                v-if="false"
                                @click.stop="exportChatReco(index)"
                        >导出聊天记录</el-button
                        >
                    </div>
                </div>
                <el-button
                        class="btn-del"
                        type="text"
                        icon="el-icon-delete"
                        v-if="chatList.length>1"
                        @click.stop="delChatReco(index)"
                ></el-button>
            </div>
        </div>
        <el-button class="btn btn-delAll" icon="el-icon-delete" @click="delChatRecoAll">清除所有对话</el-button
        >
    </div>
</template>

<script>
    import {mapState, mapActions} from "vuex";
    export default {
        name: "chatSide",
        props: {
            typeid: String,
            onActiveChat: Function,
        },
        data() {
            return {
                chatList: [],
                activeChat: 0,
                isLogin: false,
            }
        },
        computed: {
            ...mapState(['vuex_user'])
        },
        watch:{
            "vuex_user": {
                immediate: true,
                handler(newVal, oldVal) {
                    if (oldVal == null || (oldVal != undefined && !oldVal.id)) {
                        this.$nextTick(() => {
                            this.getGroupList();
                        });
                    }
                    this.isLogin = this.$myFun.isLogin();
                },
            },
        },
        mounted() {
            this.isLogin = this.$myFun.isLogin();
            this.getGroupList();
        },
        methods: {
            ...mapActions(['vuexUserLogin', 'vuexUserLogout', 'vuexInitLocalUser']),
            //更新会话
            updateGroup(index, title) {
                this.chatList[index].title = title;
                this.$axios.api.saveGroup({id: this.chatList[index].groupId, title: title}, (res) => {

                });
            },
            //获取聊天窗口列表
            getGroupList() {
                this.$axios.api.getGroupList({page: 1, pagesize: 20, typeid: this.typeid}, (res) => {
                    if (res.errno == 0) {
                        this.chatList = [];
                        let list = res.data.list;
                        for (var i=0; i<list.length; i++) {
                            this.chatList.push({
                                groupId: list[i].id,
                                title: list[i].title,
                                msgList:[]
                            });
                        }
                        this.activeChat = 0;
                        this.$nextTick(() => {
                            this.emitActiveChat();
                        });
                    } else if (res.errno == 403) {
                        // console.log("--------", res.errno);
                        //未登录
                        this.vuexUserLogout();
                    }
                });
            },
            //新建聊天窗口
            addChatGroup() {
                if (this.chatList.length > 10) {
                    this.$message.error("对话窗口最多10个！");
                } else {
                    this.$axios.api.saveGroup({title: '新聊天对话', typeid: this.typeid}, (res) => {
                        if (res.errno == 0) {
                            this.activeChat = 0;
                            this.chatList.unshift({
                                groupId: res.data.group_id,
                                title: '新聊天对话',
                                msgList:[]
                            });
                            this.$nextTick(() => {
                                this.emitActiveChat();
                            });
                        }
                    });
                }
            },
            //切换聊天窗口
            changeChatReco(index) {
                this.activeChat = index;
                this.$nextTick(() => {
                    this.emitActiveChat();
                });
            },
            //导出聊天记录
            exportChatReco(index) {},
            //删除聊天记录
            delChatReco(index) {
                this.$confirm('确定删除这条聊天对话吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$axios.api.delGroup({id: this.chatList[index].groupId}, (res) => {
                        if (res.errno == 0) {
                            this.activeChat = 0;
                            this.chatList.splice(index, 1);
                            this.$message.success("删除成功!");
                            this.emitActiveChat();
                        } else {
                            this.$message.error("删除失败!")
                        }
                    });
                }).catch(() => {

                });
            },
            //刪除全部
            delChatRecoAll(){
                this.$confirm('确定删除所有聊天对话吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$axios.api.clearGroup({typeid: this.typeid}, (res) => {
                        if (res.errno == 0) {
                            this.activeChat = 0;
                            this.chatList = [];
                            this.getGroupList();
                            this.$message.success("清空成功!");
                        } else {
                            this.$message.error("清空失败!")
                        }
                    });
                }).catch(() => {

                });
            },
            //回调函数-onActiveChat
            emitActiveChat() {
                this.$emit('onActiveChat', {activeChat: this.activeChat, groupItem: this.chatList[this.activeChat]});
            }
        }
    }
</script>

<style scoped>

</style>